export interface VCardContact {
  name: string;
  phone: string;
  email?: string;
  title?: string;
  organization?: string;
  department?: string;
  role?: string;
  homePhone?: string;
  workPhone?: string;
  mobilePhone?: string;
  faxPhone?: string;
  website?: string;
  blog?: string;
  facebook?: string;
  twitter?: string;
  linkedin?: string;
  instagram?: string;
  github?: string;
  youtube?: string;
  tiktok?: string;
  skype?: string;
  telegram?: string;
  whatsapp?: string;
  nickname?: string;
  gender?: string;
  birthdate?: string;
  anniversary?: string;
  address?: any[];
  notes?: string;
  picture?: string;
  flickrGalleryUrl?: string;
  dropboxShareUrl?: string;
  googleDriveUrl?: string;
  categories?: string[];
  interests?: string;
  expertise?: string;
}

/**
 * Generate vCard data from contact information
 */
export const generateVCardData = (contact: any, tier: string = 'FREE'): string => {
  // Create vCard lines
  const vCardLines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${contact.name || ''}`,
  ];

  // Add phone if available
  if (contact.phone) {
    vCardLines.push(`TEL;TYPE=CELL:${contact.phone}`);
  }

  // Add email if available
  if (contact.email) {
    vCardLines.push(`EMAIL:${contact.email}`);
  }

  // Add company if available (PRO feature)
  if (tier !== 'FREE' && contact.company) {
    vCardLines.push(`ORG:${contact.company}`);
  }

  // Add title if available (PRO feature)
  if (tier !== 'FREE' && contact.title) {
    vCardLines.push(`TITLE:${contact.title}`);
  }

  // Add website if available (PRO feature)
  if (tier !== 'FREE' && contact.website) {
    vCardLines.push(`URL:${contact.website}`);
  }

  // Add notes if available
  if (contact.notes) {
    vCardLines.push(`NOTE:${contact.notes}`);
  }

  // Add categories if available
  if (contact.categories && Array.isArray(contact.categories)) {
    vCardLines.push(`CATEGORIES:${contact.categories.join(',')}`);
  }

  // End vCard
  vCardLines.push('END:VCARD');

  // Return as string
  return vCardLines.join('\n');
};

// Add the openShareModal function to the window object
declare global {
  interface Window {
    openShareModal?: (contactName: string) => void;
  }
}

/**
 * Download a vCard file for a contact
 */
export const downloadVCard = (contact: any, tier: string = 'FREE'): void => {
  // Generate vCard data
  const vCardData = generateVCardData(contact, tier);
  
  // Create a blob and download link
  const blob = new Blob([vCardData], { type: 'text/vcard;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = `${contact.name || 'contact'}.vcf`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  
  // Clean up the URL object
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 100);
};